import LinkDebitCard from 'features/advance/screens/registration/LinkDebitCard/LinkDebitCard';
import React from 'react';

export default function Page() {
  return <LinkDebitCard />;
}
